import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { FIELD_LABEL_CLASS } from './formDialog.constants';

const FORM_LIST_ROWS_CLASS =
  'grid gap-y-3.5 [&>[data-slot=form-item]]:grid [&>[data-slot=form-item]]:items-baseline [&>[data-slot=form-item]]:gap-x-4 [&>[data-slot=form-item]]:gap-y-1.5 [&>[data-slot=form-item]>[data-slot=form-label]]:text-sm sm:[&>[data-slot=form-item]]:grid-cols-[10rem_minmax(0,1fr)] sm:[&_[data-slot=form-message]]:col-start-2';

const COLUMN_CLASS = {
  1: '',
  2: '@4xl:grid-cols-2 @4xl:gap-x-10',
} as const;

type FormListColumnCount = keyof typeof COLUMN_CLASS;

interface FormListProps {
  columnCount?: FormListColumnCount | undefined;
  children: ReactNode;
}

export function FormList({ columnCount = 1, children }: FormListProps) {
  return (
    <div className="@container">
      <div className={cn(FORM_LIST_ROWS_CLASS, COLUMN_CLASS[columnCount])}>{children}</div>
    </div>
  );
}

interface FormListItemProps {
  label: string;
  children: ReactNode;
}

export function FormListItem({ label, children }: FormListItemProps) {
  return (
    <div data-slot="form-item">
      <span data-slot="form-label" className={FIELD_LABEL_CLASS}>
        {label}
      </span>
      <div className="min-w-0 text-sm font-medium wrap-break-word">{children}</div>
    </div>
  );
}
